export default __webpack_public_path__ + "static/media/img-butcher-selected.fc00fe44.svg";